export default __webpack_public_path__ + "static/media/ReportIcon-Knee-MS.f1c24990.jpg";